export default __webpack_public_path__ + "static/media/swap-green.e2a20b98.svg";